var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingAutomationReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.766 0.75C17.6526 0.75 16.75 3.43629 16.75 6.75H18.766C19.7376 6.75 20.2234 6.75 20.5241 6.41455C20.8249 6.07909 20.7725 5.63733 20.6678 4.75381C20.3914 2.42143 19.6443 0.75 18.766 0.75Z",
    stroke: "#4872F4",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.80426V17.3958C16.75 18.9075 16.75 19.6633 16.288 19.9608C15.5331 20.4471 14.3661 19.4274 13.7791 19.0573C13.2941 18.7514 13.0517 18.5985 12.7825 18.5897C12.4917 18.5801 12.2449 18.7268 11.7209 19.0573L9.81 20.2624C9.2945 20.5874 9.0368 20.75 8.75 20.75C8.46321 20.75 8.20546 20.5874 7.69 20.2624L5.77913 19.0573C5.29415 18.7514 5.05166 18.5985 4.78253 18.5897C4.49172 18.5801 4.24493 18.7268 3.72087 19.0573C3.13395 19.4274 1.96687 20.4471 1.21195 19.9608C0.75 19.6633 0.75 18.9075 0.75 17.3958V6.80426C0.75 3.95025 0.75 2.52325 1.62868 1.63663C2.50736 0.75 3.92157 0.75 6.75 0.75H18.75",
    fill: "#4872F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.80426V17.3958C16.75 18.9075 16.75 19.6633 16.288 19.9608C15.5331 20.4471 14.3661 19.4274 13.7791 19.0573C13.2941 18.7514 13.0517 18.5985 12.7825 18.5897C12.4917 18.5801 12.2449 18.7268 11.7209 19.0573L9.81 20.2624C9.2945 20.5874 9.0368 20.75 8.75 20.75C8.46321 20.75 8.20546 20.5874 7.69 20.2624L5.77913 19.0573C5.29415 18.7514 5.05166 18.5985 4.78253 18.5897C4.49172 18.5801 4.24493 18.7268 3.72087 19.0573C3.13395 19.4274 1.96687 20.4471 1.21195 19.9608C0.75 19.6633 0.75 18.9075 0.75 17.3958V6.80426C0.75 3.95025 0.75 2.52325 1.62868 1.63663C2.50736 0.75 3.92157 0.75 6.75 0.75H18.75",
    stroke: "#4872F4",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4.75H12.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.75H4.75",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.625C10.4216 9.625 9.75 10.2126 9.75 10.9375C9.75 11.6624 10.4216 12.25 11.25 12.25C12.0784 12.25 12.75 12.8376 12.75 13.5625C12.75 14.2874 12.0784 14.875 11.25 14.875M11.25 9.625C11.9031 9.625 12.4587 9.9902 12.6646 10.5M11.25 9.625V8.75M11.25 14.875C10.5969 14.875 10.0413 14.5098 9.8354 14M11.25 14.875V15.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingAutomationReceiptIcon);
export default __webpack_public_path__ + "static/media/billing-automation-receipt-icon.5fe71120d18c9ea19c315e09932ae7c7.svg";
export { ForwardRef as ReactComponent };